module.exports = __webpack_public_path__ + "static/springboot-0881daccb5178410b18a1a36984da095.png";